import React from "react";
import PATH from "constants/path";
import ErrorDB from "components/ErrorDB";

const Notice = ( { noticesInit, isInLine } ) =>
{
  return (
    <div className="box-notices">
      <div className="header">
        <a href={PATH.NEWS} className="fw-500">
          <span className="me-2 d-none d-md-inline-block">
            <i className="bi bi-exclamation-circle"></i>
          </span>
          重要なお知らせ
        </a>
      </div>
      <div className="body d-flex flex-column justify-content-center">
        {isInLine && <ErrorDB/>}
        {!isInLine && noticesInit?.map((item) => (
          <div key={item.id}>
            <div className="date">
              {item.posted}({item.day_of_week})
            </div>
            <a href={"/news/detail_notice/" + item.id} className="content">
              {item.title}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notice;
